import {Component, OnInit} from '@angular/core';
import {
    ObjectBaseModeComponent
} from "../../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";


@Component({
    selector: 'as-appointment-booking-base',
    template: '',
    standalone: false
})
export class AppointmentBookingBaseComponent extends ObjectBaseModeComponent implements OnInit {


    ngOnInit() {
        super.ngOnInit();
    }


}
